// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Bus = require("../Effect.Aff.Bus/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Halogen_Aff_Util = require("../Halogen.Aff.Util/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_VDom_Driver = require("../Halogen.VDom.Driver/index.js");
var Lunarbox_Api_Request = require("../Lunarbox.Api.Request/index.js");
var Lunarbox_AppM = require("../Lunarbox.AppM/index.js");
var Lunarbox_Component_Router = require("../Lunarbox.Component.Router/index.js");
var Lunarbox_Control_Monad_Effect = require("../Lunarbox.Control.Monad.Effect/index.js");
var Lunarbox_Data_Profile = require("../Lunarbox.Data.Profile/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Routing_PushState = require("../Routing.PushState/index.js");
var prodUrl = new Lunarbox_Api_Request.BaseUrl("https://lunarbox-api.herokuapp.com", false);
var devUrl = new Lunarbox_Api_Request.BaseUrl("http://localhost:8090", true);
var main = function (production) {
    return Halogen_Aff_Util.runHalogenAff((function () {
        var baseUrl = (function () {
            if (production) {
                return prodUrl;
            };
            return devUrl;
        })();
        return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref["new"](Data_Maybe.Nothing.value)))(function (currentUser) {
            return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Aff_Bus.make(Effect_Class.monadEffectEffect)))(function (userBus) {
                return Control_Bind.bind(Effect_Aff.bindAff)(Lunarbox_Api_Request.profile(Effect_Aff_Class.monadAffAff)(baseUrl))(function (responseWithError) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)((function () {
                        if (responseWithError instanceof Data_Either.Left) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Lunarbox_Control_Monad_Effect.printString(Effect_Aff.monadEffectAff)(responseWithError.value0))(function () {
                                return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write(Data_Maybe.Nothing.value)(currentUser));
                            });
                        };
                        if (responseWithError instanceof Data_Either.Right) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Lunarbox_Control_Monad_Effect.printString(Effect_Aff.monadEffectAff)("Logged in as " + Data_Show.show(Lunarbox_Data_Profile.showUsername)(responseWithError.value0.username)))(function () {
                                return Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Effect_Ref.write(new Data_Maybe.Just(responseWithError.value0))(currentUser));
                            });
                        };
                        throw new Error("Failed pattern match at Main (line 46, column 5 - line 52, column 55): " + [ responseWithError.constructor.name ]);
                    })())(function () {
                        return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Routing_PushState.makeInterface))(function (nav) {
                            return Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (body) {
                                var env = {
                                    devOptions: new Data_Maybe.Just({
                                        cancelInputsOnBlur: true
                                    }),
                                    baseUrl: baseUrl,
                                    pushStateInterface: nav,
                                    allowedNodes: Data_Maybe.Nothing.value,
                                    user: {
                                        currentUser: currentUser,
                                        userBus: userBus
                                    }
                                };
                                var rootComponent = Halogen_Component.hoist(Halogen_HTML_Core.bifunctorHTML)(Effect_Aff.functorAff)(Lunarbox_AppM.runAppM(env))(Lunarbox_Component_Router.component(Lunarbox_AppM.monadAffAppM)(Lunarbox_AppM.monadEffectAppM)(Lunarbox_AppM.navigateAppM)(Lunarbox_AppM.monadReaderAppM)(Lunarbox_AppM.manageTutorialsAppM)(Lunarbox_AppM.manageProjectsAppM)(Lunarbox_AppM.manageGistsAppM)(Lunarbox_AppM.manageUserAppM));
                                return Control_Bind.bind(Effect_Aff.bindAff)(Halogen_VDom_Driver.runUI(rootComponent)({})(body))(function (halogenIO) {
                                    var onRouteChange = function (old) {
                                        return function ($$new) {
                                            return Control_Applicative.when(Effect.applicativeEffect)(Data_Eq.notEq(Data_Maybe.eqMaybe(Lunarbox_Data_Route.eqRoute))(old)(new Data_Maybe.Just($$new)))(Effect_Aff.launchAff_(halogenIO.query(Halogen_Query.tell(Lunarbox_Component_Router.Navigate.create($$new)))));
                                        };
                                    };
                                    return Data_Functor["void"](Effect_Aff.functorAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Routing_PushState.matchesWith(Data_Either.foldableEither)(Lunarbox_Data_Route.parseRoute)(onRouteChange)(nav)));
                                });
                            });
                        });
                    });
                });
            });
        });
    })());
};
module.exports = {
    main: main
};
